/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './mpps.reducer';

export const MPPSDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const mPPSEntity = useAppSelector(state => state.mPPS.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="mPPSDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.mPPS.detail.title">MPPS</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.mPPS.id">Id</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.id}</dd>
          <dt>
            <span id="accessionNo">
              <Translate contentKey="tinyMedicRestApp.mPPS.accessionNo">Accession No</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.accessionNo}</dd>
          <dt>
            <span id="createdTime">
              <Translate contentKey="tinyMedicRestApp.mPPS.createdTime">Created Time</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.createdTime}</dd>
          <dt>
            <span id="ppsStartDate">
              <Translate contentKey="tinyMedicRestApp.mPPS.ppsStartDate">Pps Start Date</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.ppsStartDate}</dd>
          <dt>
            <span id="ppsStartTime">
              <Translate contentKey="tinyMedicRestApp.mPPS.ppsStartTime">Pps Start Time</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.ppsStartTime}</dd>
          <dt>
            <span id="sopIuid">
              <Translate contentKey="tinyMedicRestApp.mPPS.sopIuid">Sop Iuid</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.sopIuid}</dd>
          <dt>
            <span id="ppsStatus">
              <Translate contentKey="tinyMedicRestApp.mPPS.ppsStatus">Pps Status</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.ppsStatus}</dd>
          <dt>
            <span id="studyIuid">
              <Translate contentKey="tinyMedicRestApp.mPPS.studyIuid">Study Iuid</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.studyIuid}</dd>
          <dt>
            <span id="updatedTime">
              <Translate contentKey="tinyMedicRestApp.mPPS.updatedTime">Updated Time</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.updatedTime}</dd>
          <dt>
            <span id="dicomAttrs">
              <Translate contentKey="tinyMedicRestApp.mPPS.dicomAttrs">Dicom Attrs</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.dicomAttrs}</dd>
          <dt>
            <span id="discreasonCode">
              <Translate contentKey="tinyMedicRestApp.mPPS.discreasonCode">Discreason Code</Translate>
            </span>
          </dt>
          <dd>{mPPSEntity.discreasonCode}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mPPS.patient">Patient</Translate>
          </dt>
          <dd>{mPPSEntity.patient ? mPPSEntity.patient.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.mPPS.accnoIssuer">Accno Issuer</Translate>
          </dt>
          <dd>{mPPSEntity.accnoIssuer ? mPPSEntity.accnoIssuer.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/mpps" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/mpps/${mPPSEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default MPPSDetail;
